import React, { memo, useEffect, useState, useCallback } from 'react';
import styles from './Collect.module.less';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import MessageLine from '../MessageLine/MessageLine';
import {
  // deleteMessageHot,
  getMessageList,
} from '../../../actions/message';
import InfiniteScroll from 'react-infinite-scroller';

const selectMessage = createSelector(
  state => state.message,
  message => ({
    collectList: message.collectList || [],
    messageHot: message.hot,
    collectPagenation: message.collectPagenation,
    collectLoading: message.collectLoading,
  }),
);
export default memo(() => {
  const [node, setNode] = useState(null);
  const dispatch = useDispatch();
  const {
    collectList,
    // messageHot,
    collectPagenation,
    collectLoading,
  } = useSelector(selectMessage);
  useEffect(() => {
    // if (messageHot && messageHot[2] === '1') {
    // dispatch(deleteMessageHot({ code: 2 }));
    // }
  }, []);

  const loadMore = useCallback(() => {
    if (!collectLoading) {
      dispatch(getMessageList({ code: 1, skip: collectList.length, limit: 24, refresh: false }));
    }
  });
  return (
    <div className={styles.collect} ref={r => setNode(r)}>
      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        hasMore={collectList.length < collectPagenation.count}
        loader={
          <div className="loader" key={0}>
            ----------加载中----------
          </div>
        }
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => node}
      >
        {collectList &&
          collectList.map(collect => (
            <MessageLine message={collect} key={collect.id} isComment={false} />
          ))}
      </InfiniteScroll>
    </div>
  );
});
